export const GET_COMPANY_SUMMARY_REQUEST = 'GET_COMPANY_SUMMARY_REQUEST';
export const GET_COMPANY_SUMMARY_SUCCESS = 'GET_COMPANY_SUMMARY_SUCCESS';
export const GET_COMPANY_SUMMARY_ERROR = ' GET_COMPANY_SUMMARY_ERROR';
